import api, { Notifiable } from './api';
import { date, number } from 'yup';

export interface Filter {
  codigoProjetoFormulario: string;
  nomeProjetoFormulario: string;
  statusModuloEconomicoContratadoFormulario: string[];

  codigoOrdemInvestimentoFormulario: string;
  nomeOrdemInvestimentoFormulario: string;
  numeroOrdemInvestimentoFormulario: string;

  numeroRequisicaoCompraFormulario: number;
  numeroItemRequisicaoCompraFormulario: number;
  statusRequisicaoCompraFormulario: string[];

  numeroOrdemCompraFormulario: number;
  dataEmissaoOrdemCompraFormulario: Date;

  numeroPedidoCompraFormulario: number;
  tipoPedidoCompraFormulario: string;

  nomeFornecedorPedidoCompraFormulario: string;
  numeroContratoPcsFormulario: number;

  centroCustoFormulario: string;
  contaContabilFormulario: string;
}

export interface CtrPcsResultData {
  row: number;
  id: string;
  pcmId: string;

  ordemInvestimentoRequisicaoCompraSeqId: string;

  //[OrdemInvestimento.CodigoPacote]
  pacoteOiCodigo: string;

  //[OrdemInvestimento.Nome]
  pacoteOiNome: string;

  //[OrdemInvestimento.Numero]
  pacoteOiOi: string;

  //[Projeto.Nome]
  pacoteOiProjeto: string;

  pacoteOiNumero: string;

  //[RequisicaoCompra.Numero]
  rcNumero: string;

  //[RequisicaoCompraSeq.Seq]
  rcSeq: string;

  //[RequisicaoCompraSeq.StatusRequisicaoCompraSeqId.Nome]
  rcStatus: string;

  //[RequisicaoCompraSeq.Narrativa];
  rcNarrativa: string;

  //[OrdemCompra.Numero]
  ocNumero: string;

  //[OrdemCompra.DataEmissao]
  ocData: string;

  //[PCM.Numero]
  pedidoPcm: string;

  //[PCM.TipoDePedido]
  pedidoTipo: string;

  //[PCM.FornecedorNome]
  pedidoFornecedor: string;

  //[ContratoPcs.Numero]
  pedidoCtPcs: string;
}

export interface Distribuicao {
  //distribuicaoItemResult: ContratadoAno[];
  resultDataTabel: ContratadoAno[];
  anos: number[];
}

export interface ContratadoAno {
  pcmId: string;
  requisicaoCompraSeqId: string;
  ordemInvestimentoId: string;
  ordemInvestimentoRequisicaoCompraSeqId: string;
  moduloEconomicoContratadoId: string;
  ordemCompraId: string;

  ordemInvestimentoRequisicaoCompraSeqPrincial: boolean;

  pacoteProjeto: string;
  pacotePctOi: string;

  requisicaoCompraNumero: number;
  requisicaoCompraSeq: string;
  requisicaoCompraPrecoUnitarioFormatado: string;
  requisicaoCompraPrecoUnitario: number;
  requisicaoCompraQuantidadeTotal: string;
  requisicaoCompraValorTotal: number;
  requisicaoCompraValorTotalFormatado: string;
  requisicaoCompraOc: string;

  pedidoPcm: string;
  pedidoCtPcs: string;
  pedidoCtPreUnitarioFormatado: string;
  valorUnitarioPedido: number;

  valorFormatado: string;
  quantidadeFormatado: string;
}

export interface ContratadoAnoTipoOverHead {
  ordemInvestimentoId: string;
  ordemInvestimentoRequisicaoCompraSeqId: string;
  moduloEconomicoContratadoId: string;
  pacoteProjeto: string;
  pacotePctOi: string;
  requisicaoCompraQuantidadeTotal: string;
  requisicaoCompraValorTotal: number;
  requisicaoCompraValorTotalFormatado: string;
  pedidoCtPreUnitarioFormatado: string;
  valorUnitarioPedido: number;
  valorFormatado: string;
  quantidadeFormatado: string;
  numero: string;
}

export interface DistribuicaoContratadoOverHead {
  resultDataTabel: ContratadoAnoTipoOverHead[];
  anos: number[];
}

export interface PropFormulario {
  codigoProjetoFormulario: string;
  nomeProjetoFormulario: string;
  statusModuloEconomicoContratadoFormulario: string[];
  codigoOrdemInvestimentoFormulario: string;
  nomeOrdemInvestimentoFormulario: string;
  numeroOrdemInvestimentoFormulario: string;
  numeroRequisicaoCompraFormulario: string;

  numeroItemRequisicaoCompraFormulario: string;
  statusRequisicaoCompraFormulario: string[];

  numeroOrdemCompraFormulario: string;
  dataEmissaoOrdemCompraFormulario?: string;

  numeroPedidoCompraFormulario: string;
  tipoPedidoCompraFormulario: string;

  nomeFornecedorPedidoCompraFormulario: string;
  numeroContratoPcsFormulario: string;
  mudarValor?: boolean;
  centroCustoFormulario: string;
  contaContabilFormulario: string;
}

export const getCtrPcsData = (values: Filter = {}) => {
  return api.post<CtrPcsResultData[]>('contratopcs/GetCtrPcsData', values, {
    disableNotification: 'true',
  });
};

export const getCtrPcmData = (values: Filter = {}) => {
  return api.post<CtrPcsResultData[]>('contratadopcm/getAllcontratadopcm', values, {
    disableNotification: 'true',
  });
};

export const getAllRequisitadoOcData = (values: Filter = {}) => {
  return api.post<CtrPcsResultData[]>('requisitadoOc/getAllRequisitadoOc', values, {
    disableNotification: 'true',
  });
};

export const getAllRequisitadoRc = (values: Filter = {}) => {
  return api.post<CtrPcsResultData[]>('requisitadoOc/getAllRequisitadoRc', values, {
    disableNotification: 'true',
  });
};

export const getAllContratoAno = (id: any) => api.get<Distribuicao>(`contratopcs/getAllContratoAno/${id}`);

//export const deleteDistribuicaoItem = (id: any) => api.delete<any>(`contratopcs/deleteDistribuicaoItem/${id}`);

export const deleteDistribuicaoItem = (id: any) => api.get<Notifiable>(`contratopcs/deleteDistribuicaoItem/${id}`);

export const obterNarativaPorOrdemInvestimentoRequisicaoCompraSeqId = (id: any) =>
  api.get<string>(`contratopcs/obterNarativaPorOrdemInvestimentoRequisicaoCompraSeqId/${id}`);

export const adcionarLinhaItemRateavel = (ordemInvestimentoId: any, requisicaoCompraSeqId: string) => {
  const form = new FormData();
  form.append('ordemInvestimentoId', ordemInvestimentoId);
  form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
  return api.post<any>(`contratopcs/adcionarLinhaItemRateavel`, form);
};

export const adcionarColunaItemRateavel = (requisicaoCompraSeqId: any) => {
  const form = new FormData();
  form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);

  return api.post<any>(`contratopcs/adcionarColunaItemRateavel`, form);
};

export const atualizarValorContratadoAno = (
  moduloEconomicoContratadoId: any,
  ordemInvestimentoId: any,
  requisicaoCompraSeqId: any,
  ordemCompraId: any,
  valorAlterado: string,
  ano: string,
) => {
  const form = new FormData();
  form.append('moduloEconomicoContratadoId', moduloEconomicoContratadoId);
  form.append('ordemInvestimentoId', ordemInvestimentoId);
  form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
  form.append('valorAlterado', valorAlterado);
  form.append('valorAlteradoDecimal', valorAlterado);
  form.append('ano', ano);
  form.append('anoTexto', ano);

  return api.post<any>(`contratopcs/atualizarValorContratadoAno`, form);
};

export const concluirrateioctpcm = (ordemInvestimentoRequisicaoCompraSeqId: string) => {
  const form = new FormData();
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);
  return api.post<any>(`contratopcs/concluirrateioctpcm`, form);
};

export const adicionarColunaItemTipoOverHead = (numero: any) => {
  const form = new FormData();
  form.append('Numero', numero);
  return api.post<any>(`contratopcs/adicionarColunaItemTipoOverHead`, form);
};

export interface CtrSemVinculoResultData {
  row: number;
  id: string;
  pcmId: string;

  // ordemInvestimentoRequisicaoCompraSeqId: string;

  // //[OrdemInvestimento.CodigoPacote]
  // pacoteOiCodigo: string;

  // //[OrdemInvestimento.Nome]
  // pacoteOiNome: string;

  // //[OrdemInvestimento.Numero]
  // pacoteOiOi: string;

  // //[Projeto.Nome]
  // pacoteOiProjeto: string;

  requisicaoCompraSeqId: string;

  numeroCentroDeCusto: string;

  numeroContaContabil: string;

  pacoteOiNumero: string;

  //[RequisicaoCompra.Numero]
  rcNumero: string;

  //[RequisicaoCompraSeq.Seq]
  rcSeq: string;

  //[RequisicaoCompraSeq.StatusRequisicaoCompraSeqId.Nome]
  rcStatus: string;

  //[RequisicaoCompraSeq.Narrativa];
  rcNarrativa: string;

  //[OrdemCompra.Numero]
  ocNumero: string;

  //[OrdemCompra.DataEmissao]
  ocData: string;

  //[PCM.Numero]
  pedidoPcm: string;

  //[PCM.TipoDePedido]
  pedidoTipo: string;

  //[PCM.FornecedorNome]
  pedidoFornecedor: string;

  //[ContratoPcs.Numero]
  pedidoCtPcs: string;
}

export const getCtrSemVinculoData = (values: Filter = {}) => {
  return api.post<CtrSemVinculoResultData[]>('contratadosemvinculo/getCtrSemVinculoOi', values, {
    disableNotification: 'true',
  });
};

export const getAllContratoAnoSemVinculo = (id: any) =>
  api.get<Distribuicao>(`contratopcs/getAllContratoAnoSemVinculo/${id}`);

export const adcionarLinhaItemSemVinculoRateavel = (ordemInvestimentoId: any, requisicaoCompraSeqId: string) => {
  const form = new FormData();
  form.append('ordemInvestimentoId', ordemInvestimentoId);
  form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
  return api.post<any>(`contratopcs/adcionarLinhaItemSemVinculoRateavel`, form);
};

export const atualizarValorContratadoAnoSemVinculoOi = (
  moduloEconomicoContratadoId: any,
  ordemInvestimentoId: any,
  requisicaoCompraSeqId: any,
  ordemCompraId: any,
  valorAlterado: string,
  ano: string,
) => {
  const form = new FormData();
  form.append('moduloEconomicoContratadoId', moduloEconomicoContratadoId);
  form.append('ordemInvestimentoId', ordemInvestimentoId);
  form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);
  form.append('valorAlterado', valorAlterado);
  form.append('valorAlteradoDecimal', valorAlterado);
  form.append('ano', ano);
  form.append('anoTexto', ano);

  return api.post<any>(`contratopcs/atualizarValorContratadoAnoSemVinculo`, form);
};

export const adcionarColunaItemSemVinculoRateavel = (requisicaoCompraSeqId: any) => {
  const form = new FormData();
  form.append('requisicaoCompraSeqId', requisicaoCompraSeqId);

  return api.post<any>(`contratopcs/adcionarColunaItemSemVinculoRateavel`, form);
};

export const deleteDistribuicaoSemVinculoItem = (id: any) =>
  api.get<Notifiable>(`contratopcs/deleteDistribuicaoSemVinculoItem/${id}`);

export const concluirrateioctpcmSemVinculo = (ordemInvestimentoRequisicaoCompraSeqId: string) => {
  const form = new FormData();
  form.append('ordemInvestimentoRequisicaoCompraSeqId', ordemInvestimentoRequisicaoCompraSeqId);
  return api.post<any>(`contratopcs/concluirrateioctpcmSemVinculo`, form);
};

export const adcionarColunaItemTipoOverHead = (numero: any) => {
  const form = new FormData();
  form.append('Numero', numero);
  return api.post<any>(`contratopcs/adcionarColunaItemTipoOverHead`, form);
};